import { render, staticRenderFns } from "./MoedaList.vue?vue&type=template&id=f1b415bc&scoped=true"
import script from "./MoedaList.vue?vue&type=script&lang=js"
export * from "./MoedaList.vue?vue&type=script&lang=js"
import style0 from "./MoedaList.vue?vue&type=style&index=0&id=f1b415bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b415bc",
  null
  
)

export default component.exports